@if(showLanguageDropdown === true) {
  <button mat-raised-button [matMenuTriggerFor]="menu"
    aria-label="Open language menu"
    aria-haspopup="true"
    aria-expanded="false"
    id="language-dropdown-button"
    i18n-aria-label
  >
    <span style="display: flex; align-items: center; gap: 5px;">
      <mat-icon style="color: #253E60;">language</mat-icon>
      @if (!isMobileScreen) {
        <span  style="color: #253E60;" i18n>LANGUAGE</span>
      }
      @if(isMenuOpen){
        <mat-icon style="color: #253E60;">keyboard_arrow_up</mat-icon>
      } @else {
        <mat-icon style="color: #253E60;">keyboard_arrow_down</mat-icon>
      }  
    </span>
  </button>

  <mat-menu #menu="matMenu">
    @for(language of languages; track language) {
      <button mat-menu-item  (click)="onLanguageChange(language.code)">
        <mat-icon>flag</mat-icon>
        <span>{{language.label}}</span>
      </button>
    }
  </mat-menu>
}
